window.apisExactExportBanksDetailFormatter = function(value, row) {
    let html = '';
    let data = JSON.parse(row.data);
    if (data != null && Object.keys(data).length > 0) {
        html += '<div class="form-group">';
        html += "<label>"+__('Response')+"</label>";
        html += '<textarea class="form-control" rows="3">'+row.data+"</textarea>";
        html += '</div>';
        html += '<div class="mt-3"></div>';
        html += '<table class="table table-borderless table-hover table-responsive table-sm table-striped text-nowrap">';
        html += '<thead>';
        html += '<tr>';
        html += '<th>'+__('Name')+'</th>';
        html += '<th>'+__('BIC')+'</th>';
        html += '<th>'+__('Country')+'</th>';
        html += '</tr>';
        html += '</thead>';
        html += '<tbody>';
        data.sort((a, b) => a.BankName.localeCompare(b.BankName));
        for (let i = 0; i < data.length; i++) {
            let businessType = data[i];
            html += '<tr>';
            html += '<td>'+businessType.BankName+'</td>';
            html += '<td>'+businessType.BICCode+'</td>';
            html += '<td>'+businessType.Country+'</td>';
            html += '</tr>';
        }
        html += '</tbody>';
        html += '</table>';
    }
    return html;
};

